import * as React from "react"
import {Switch} from "@headlessui/react"

/**
 * @typedef {object} SwitchButtonProps
 * @property {React.ReactNode} [children]
 * @property {string} [className]
 * @property {boolean} [checked]
 * @property {boolean} [defaultChecked]
 * @property {(checked: boolean) => void} [onChange]
 * @property {boolean} [disabled]
 */

/**
 * @type {React.FC<SwitchButtonProps>}
 */
const SwitchButton = ({className, ...restProps}) => {
  return (
    <Switch
      {...restProps}
      className={`
        w-24 p-1 rounded-full
        ui-checked:bg-blue-primary ui-not-checked:bg-gray-silver
        dark:ui-not-checked:bg-blue-night
        lg:w-16
        ${className}
      `}
    >
      <div className="w-11 h-11 lg:w-7 lg:h-7 bg-white rounded-full transition ui-not-checked:translate-x-0 ui-checked:translate-x-11 lg:ui-checked:translate-x-7" />
    </Switch>
  )
}

export default SwitchButton
